import { render, staticRenderFns } from "./teamDetail.vue?vue&type=template&id=666adb5d&scoped=true&"
import script from "./teamDetail.vue?vue&type=script&lang=js&"
export * from "./teamDetail.vue?vue&type=script&lang=js&"
import style0 from "./teamDetail.vue?vue&type=style&index=0&id=666adb5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666adb5d",
  null
  
)

export default component.exports